import { render, staticRenderFns } from "./changeLPwdDc.vue?vue&type=template&id=34a4cdad&scoped=true"
import script from "./changeLPwdDc.vue?vue&type=script&lang=js"
export * from "./changeLPwdDc.vue?vue&type=script&lang=js"
import style0 from "./changeLPwdDc.vue?vue&type=style&index=0&id=34a4cdad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a4cdad",
  null
  
)

export default component.exports